/*
  Gives every product title in a grid row the same height, so images, descriptions
  and buttons line up no matter whether a title wraps to 1 or 4 lines.
  Re-runs on resize, font load, image load and when grids are re-rendered (filters, pagination).
*/
(() => {
  const TITLE_SELECTOR = '.product-card-wrapper > .card__content:first-child';
  const observedGrids = new WeakSet();

  function equalizeGrid(grid) {
    const titles = Array.from(grid.querySelectorAll(`:scope > .grid__item ${TITLE_SELECTOR}`));
    if (!titles.length) return;

    titles.forEach((title) => title.style.removeProperty('--grcrst-title-height'));

    // Read pass: group titles by the row their grid item sits on
    const rows = new Map();
    titles.forEach((title) => {
      const top = title.closest('.grid__item').offsetTop;
      if (!rows.has(top)) rows.set(top, { titles: [], height: 0 });
      const row = rows.get(top);
      row.titles.push(title);
      row.height = Math.max(row.height, title.getBoundingClientRect().height);
    });

    // Write pass
    rows.forEach((row) => {
      if (row.titles.length < 2) return;
      row.titles.forEach((title) => title.style.setProperty('--grcrst-title-height', `${Math.ceil(row.height)}px`));
    });
  }

  const resizeObserver = new ResizeObserver((entries) => {
    entries.forEach((entry) => equalizeGrid(entry.target));
  });

  function getGrids() {
    const grids = new Set();
    document.querySelectorAll('.grid__item > .product-card-wrapper').forEach((card) => {
      const grid = card.parentElement.parentElement;
      if (grid) grids.add(grid);
    });
    return grids;
  }

  function scan() {
    getGrids().forEach((grid) => {
      if (observedGrids.has(grid)) return;
      observedGrids.add(grid);
      resizeObserver.observe(grid);
    });
  }

  function equalizeAll() {
    getGrids().forEach(equalizeGrid);
  }

  let scheduled = false;
  const mutationObserver = new MutationObserver(() => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => {
      scheduled = false;
      scan();
    });
  });

  function init() {
    scan();
    mutationObserver.observe(document.body, { childList: true, subtree: true });
    if (document.fonts) document.fonts.ready.then(equalizeAll);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
